<div style="width: 900px; height: 850px;" data-cy="insurance-company-picker-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="insurance-company-picker-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="insurance-company-picker-header">
      <div class="section-header-title" data-cy="insurance-company-picker-title">
        Select Insurance Company
      </div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1; display: flex; flex-direction: column; height: 500px;" data-cy="insurance-company-picker-content">
      <app-tdo-progress-spinner style="height: 100%;" *ngIf="isLoading" data-cy="insurance-company-picker-loading"></app-tdo-progress-spinner>
      <div *ngIf="!isLoading" style="flex: 1; overflow: auto;" data-cy="insurance-company-picker-table-container">

        <!--          body of modal-->
        <tdo-table #orgTable [searchPredicate]="searchPredicate" (rowSelected)="onOrganizationRowSelected($event)" [dataSource]="dataOrganizations" [isUsePaginator]="true" [pageSizeOptions]="[25, 50, 75, 100]" sortActive="OrganizationName" sortDirection="asc" data-cy="insurance-company-picker-table">
          <tdo-table-column [isSortable]="true" displayName="Name" propertyName="name" [rowTemplate]="nameTemplate" data-cy="insurance-company-picker-name-column">
            <ng-template let-row #nameTemplate>
              <div style="display: flex;" data-cy="insurance-company-picker-name-cell-{{row.index}}">
                <div (click)="row.model.isExpanded = true;" style="flex-basis: 30px; position: relative; top: 2px;" *ngIf="!row.model.isExpanded" data-cy="insurance-company-picker-expand-{{row.index}}"><mat-icon>expand_more</mat-icon></div>
                <div (click)="row.model.isExpanded = false;" style="flex-basis: 30px; position: relative; top: 2px;" *ngIf="row.model.isExpanded" data-cy="insurance-company-picker-collapse-{{row.index}}"><mat-icon>expand_less</mat-icon></div>
                <div style="flex: 1; margin-bottom: 4px;" data-cy="insurance-company-picker-name-content-{{row.index}}">
                  <div style="margin-bottom: 4px; position: relative; top: 4px;" data-cy="insurance-company-picker-org-name-{{row.index}}">{{row.model.OrganizationName}} </div>
                  <ng-container *ngIf="row.model.isExpanded">
                    <div style="display: flex" data-cy="insurance-company-picker-expanded-{{row.index}}">
                      <div style="flex:1" data-cy="insurance-company-picker-address-container-{{row.index}}">
                        <span style="font-weight: bold; color: var(--tdo-primary)" data-cy="insurance-company-picker-address-label-{{row.index}}">Address</span>
                        <div *ngIf="row.model.dataAddress" data-cy="insurance-company-picker-address-{{row.index}}">
                          <div *ngIf="row.model.dataAddress.Address1" data-cy="insurance-company-picker-address1-{{row.index}}">{{ row.model.dataAddress.Address1 }}</div>
                          <div *ngIf="row.model.dataAddress.Address2" data-cy="insurance-company-picker-address2-{{row.index}}">{{ row.model.dataAddress.Address2 }}</div>
                          <div *ngIf="row.model.dataAddress.Address3" data-cy="insurance-company-picker-address3-{{row.index}}">{{ row.model.dataAddress.Address3 }}</div>
                          <div data-cy="insurance-company-picker-city-state-zip-{{row.index}}">{{ row.model.dataAddress.City ? row.model.dataAddress.City + ', ' : '' }} {{ row.model.dataAddress.State ? row.model.dataAddress.State : '' }} {{ row.model.dataAddress.PostCode ? row.model.dataAddress.PostCode : '' }}</div>
                        </div>
                        <div *ngIf="!row.model.dataAddress" data-cy="insurance-company-picker-no-address-{{row.index}}">
                          No address
                        </div>
                      </div>
                      <div style="flex:1" data-cy="insurance-company-picker-contacts-container-{{row.index}}">
                        <span style="font-weight: bold; color: var(--tdo-primary)" data-cy="insurance-company-picker-contacts-label-{{row.index}}">Contacts</span>
                        <div *ngIf="row.model.dataOrganizationContacts" data-cy="insurance-company-picker-contacts-{{row.index}}">
                          <div data-cy="insurance-company-picker-contacts-list-{{row.index}}">
                            {{ returnOrganizationContactsString(row.model.dataOrganizationContacts) }}
                          </div>

                        </div>
                        <div *ngIf="!row.model.dataOrganizationContacts" data-cy="insurance-company-picker-no-contacts-{{row.index}}">
                          No contacts
                        </div>
                      </div>
                    </div>


                  </ng-container>
                </div>
              </div>
            </ng-template>
          </tdo-table-column>


          <tdo-table-column [isSortable]="false" displayName="Fee Schedule(s)" propertyName="fee" [rowTemplate]="feeTemplate" data-cy="insurance-company-picker-fee-column">
            <ng-template let-row #feeTemplate>
              <div data-cy="insurance-company-picker-fee-cell-{{row.index}}">
                {{returnOrganizationFeeScedulesString(row.model.dataFeeSchedules)}}
              </div>
            </ng-template>
          </tdo-table-column>




        </tdo-table>

      </div>

    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 60px; padding-top: 10px;" data-cy="insurance-company-picker-footer">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="close(false)" class="tdo-button tdo-close" style="margin-right: 10px;" data-cy="insurance-company-picker-cancel-button">Cancel</button>
      <button (click)="OrganizationChosen()"
              [disabled]="!this.dataOrganization" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="insurance-company-picker-select-button">Select Organization</button>
      <button (click)="AddOrganization()"
              class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="insurance-company-picker-add-button">Add Organization</button>
    </div>

  </div>
</div>
